import React from "react";
import { CTAButton } from "./CTAButton";
import { images } from "../data/content";
export function Author() {
  return <section className="w-full bg-cream px-4 py-16 sm:py-20" data-id="element-20" data-mp="oil4pk6v8kv1">
      <div className="mx-auto max-w-5xl" data-id="element-21" data-mp="9t5fi8mzgnhg">
        <div className="text-center" data-id="element-22" data-mp="9ugiw7cint81">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-gold-dark sm:text-sm" data-id="element-23" data-mp="erzv71pnlvxc">
            Why I created Insulin Resistance Nutrition Blueprint™
          </p>
          <h2 className="mt-3 font-serif text-[30px] font-bold leading-[1.12] text-navy sm:text-4xl md:text-5xl" data-id="element-24" data-mp="12fhs1bnrzk76">
            A message from Dr. Henry Wells
          </h2>
        </div>

        <div className="mt-10 grid items-start gap-8 md:grid-cols-[minmax(0,2fr)_minmax(0,3fr)] md:gap-12" data-id="element-25" data-mp="siv6eknmkp43">
          <div className="mx-auto w-full max-w-sm overflow-hidden rounded-3xl ring-4 ring-gold md:sticky md:top-8" data-id="element-26" data-mp="xgn1tonhatd1">
            <img src={images.author} alt="Dr. Henry Wells" className="aspect-[4/5] w-full object-cover object-top" data-id="element-27" data-mp="3dbynm5wzsk48" />
          </div>

          <div className="space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-28" data-mp="1ty25xwfmtcpa">
            <p data-id="element-29" data-mp="1ozh4xusk2ozs">
              When working with insulin resistance and metabolic health, one challenge becomes clear very quickly.
            </p>
            <p data-id="element-30" data-mp="2301kmi36c4p2">Nutrition care involves far more than discussing a single food, measurement, or lifestyle habit.</p>
            <p data-id="element-31" data-mp="1xyucghx4d3hv">
              A patient's nutritional history, eating patterns, health information, individual goals, previous experiences, and
              ongoing follow-up may all need to be considered. And organizing that information for practical use can be
              challenging when time is limited.
            </p>
            <p data-id="element-32" data-mp="2ho4sxy4ovsh1">Over time, I recognized an important distinction:</p>
            <p className="border-l-4 border-gold pl-4 font-serif text-xl font-bold leading-snug text-navy sm:text-2xl" data-id="element-33" data-mp="2hoy3792ux03x">
              Having access to information and having a practical system for organizing it are two different things.
            </p>
            <p data-id="element-34" data-mp="1obyc9mbs8avi">
              A nutrition professional may already understand the fundamentals of insulin resistance and have access to excellent
              clinical resources, yet still benefit from a clearer way to structure the information relevant to a particular
              consultation.
            </p>
            <p data-id="element-35" data-mp="223v2fktw4ap9">
              That is why I created <strong className="text-ink" data-id="element-36" data-mp="224we9riqd181">Insulin Resistance Nutrition Blueprint™</strong> — to bring the
              major stages of insulin resistance nutrition care together in one structured collection that professionals could
              review, print, and adapt without creating an entirely new organizational system from scratch.
            </p>
            <p data-id="element-37" data-mp="2l1xmdl7kzhg7">
              Rather than creating another lengthy educational program that requires hours of study before you can use it, I
              focused on practical reference materials, worksheets, checklists, and visual navigation tools.
            </p>
            <p data-id="element-38" data-mp="j45a3oamfd8l">
              My intention is not to replace your expertise or dictate decisions for every patient. It's to help you organize the
              information you already use and approach your consultations with a clearer structure.
            </p>
            <p className="font-semibold text-ink" data-id="element-39" data-mp="9evdpw8qv8eo">
              Because a well-organized clinical workflow should support your professional judgment, not replace it.
            </p>
            <p className="font-serif text-2xl font-bold italic text-navy" data-id="element-40" data-mp="121ol2xgn35xn">— Dr. Henry Wells</p>
          </div>
        </div>

        <div className="mt-12" data-id="element-41" data-mp="x4ppsbl8osxv">
          <CTAButton label="I want Dr. Wells' Insulin Resistance Blueprint" note="One-Time Payment of $27 USD · Instant Download · 7-Day Money-Back Guarantee" data-id="element-42" data-mp="s4jvsorhyucm" />
        </div>
      </div>
    </section>;
}